import { Input, TimePicker, Button, Checkbox } from "@ds/ds-snam/react";
import { INotificationAction, NotificationsStatusType } from "dataModels/stateModels/notification";
import {
    IMoveReservationParameters,
    IParametersFreezing,
    IShipper,
} from "dataModels/settings";
import moment from "moment";
import { getMoveReservationParams, getParametersFreezing, getShipperList, postMoveReservationParams, putParametersFreezing } from "net/settings";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
    AppUserRole,
    DsLayout,
    IAppUserProfile,
    ResponseCode,
    ResponseStatus,
    RoutePath,
    TIME_FORMAT,
} from "shared/constants";
import {
    hideNotification,
    showNotification,
} from "state/reducer/notificationSlice";
import {
    requestPending,
    requestPristine,
} from "state/reducer/requestStatusSlice";
import { RootState } from "state/appStore";
import useAppUser from "hooks/useAppUser";
import { AppUser } from "ooAuth2/appUser";
import { Input as TextInput } from "@ds/ds-snam/react";
import { current } from "@reduxjs/toolkit";
import MyBookingModal from "views/b2bView/components/bookingData/components/myBookingModal";
import { useNavigate } from "react-router";


const MoveReservationParametersView: React.FC<{}> = (): JSX.Element => {
    const [formData, setFormData] =useState<IMoveReservationParameters|undefined>(undefined);
    const [viewConfirmModal,setViewConfirmModal] = useState<boolean>(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation(["contract", "app"]);
    const layoutMode = useSelector((state: RootState) => {
        return state.dsLayout.mode;
    });
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const appUserProfile: IAppUserProfile | undefined = appUser?.userProfile;

    const loadData = useCallback(() => {
        dispatch(requestPending());
        getMoveReservationParams()
            .then((data: IMoveReservationParameters) => {
                setFormData(data);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            });
    }, [dispatch]);

    useEffect(() => {
        loadData();
    }, [loadData]);


    const postData = () => {
        if(formData!==undefined){
            let popUpAction: INotificationAction;
            dispatch(requestPending());
            postMoveReservationParams(formData)
                .then(response => {
                    const popUpTitle:string = response.data.status===ResponseStatus.ERROR ? 'Error':(response.data.code===ResponseCode.UNPROCESSABLE_CONTENT? 'Unprocessable content': t("settings.moveParameters.sub_title.4") );
                    const popUpDescription:string = response.data.status===ResponseStatus.ERROR||response.data.code===ResponseCode.UNPROCESSABLE_CONTENT?response.data.message:t("settings.moveParameters.sub_title.5");
                    const popUpStatus:NotificationsStatusType = response.data.status===ResponseStatus.ERROR?"error":(response.data.code===ResponseCode.UNPROCESSABLE_CONTENT?"warning":"confirm");         
                    popUpAction = {
                        show: true,
                        title: popUpTitle,
                        description: popUpDescription,
                        status: popUpStatus,
                        onClose: (event: Event) => {
                            dispatch(hideNotification());
                        }
                    };
                    dispatch(showNotification(popUpAction));
                    setViewConfirmModal(false)
                    navigate(RoutePath.SETTINGS_MOVE_PARAMETERS);                   
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    dispatch(requestPristine());
                });
        }
    }



    return (
        <>
            <p className="pageTitle">
                {t("settings.moveParameters.title")}{" "}
                {/*Freezing date e short term*/}
            </p>
            {/*<p className="pageSubTitle">
                {t('settings.slotFreezing.sub_title.0')} 
            </p>*/}
            <div className="listTableContainerGrey">
                <Row>
                    <Col>
                        <p className="formSubTitle">
                            {t("settings.moveParameters.sub_title.0")}
                        </p>
                    </Col>
                </Row>
                {formData &&<><Row style={{ marginBottom: "24px" }}>
                    <Col>
                        <Checkbox
                            checkboxId="isActive"
                            checkboxStatus="default"
                            checkboxLabel={t("settings.moveParameters.sub_title.1")}
                            elementResetPair=""
                            isDisabled={false}
                            isChecked={formData?.isActive}
                            isRequired={false}
                            onCheckboxChange={(event:Event)=>{
                                let value = (event as CustomEvent).detail.checkbox.checked;
                                let currentFormData = { ...formData };
                                currentFormData.isActive = value;
                                setFormData(currentFormData);
                            }}>
                        </Checkbox>
                    </Col>
                </Row>
                 <Row style={{ marginBottom: "12px" }}>
                    <Col xs={12} md={4}>
                        <TextInput
                            inputLabel={t("settings.moveParameters.sub_title.3")}
                            inputValue={formData.hoursAfter.toString()}
                            inputName="hoursAfter"
                            inputId="hours-after"
                            inputDescription=""
                            inputStatus="default"
                            inputPlaceholder=""
                            isDisabled={!formData.isActive}
                            input-event-type="single_character"
                            isNumberVariant={true} //STRINGTOONLYNUMBER
                            isReadonly={false}
                            onInputChange={(inputEvent: Event) => {
                                const fieldName = "hoursAfter";
                                let currentData: IMoveReservationParameters = { ...formData };
                                if ((inputEvent as CustomEvent).detail.input.value !== "") {
                                    (currentData[fieldName as keyof IMoveReservationParameters] as number) = Number((inputEvent as CustomEvent).detail.input.value);
                                } else {
                                    (currentData[fieldName as keyof IMoveReservationParameters] as number) = 0;
                                }
                                setFormData(currentData);
                            }}
                        />
                    </Col>
                    <Col xs={12} md={4}>
                        <TextInput
                            inputLabel={t("settings.moveParameters.sub_title.2")}
                            inputValue={formData.hoursBefore.toString()}
                            inputName="hoursBefore"
                            inputId="hours-before"
                            inputDescription=""
                            inputStatus="default"
                            inputPlaceholder=""
                            isDisabled={!formData.isActive}
                            input-event-type="single_character"
                            isNumberVariant={true} //STRINGTOONLYNUMBER
                            isReadonly={false}
                            onInputChange={(inputEvent: Event) => {
                                const fieldName = "hoursBefore";
                                let currentData: IMoveReservationParameters = { ...formData };
                                if (
                                    (inputEvent as CustomEvent).detail.input
                                        .value !== ""
                                ) {
                                    (currentData[fieldName as keyof IMoveReservationParameters] as number) = Number((inputEvent as CustomEvent).detail.input.value);
                                } else {
                                    (currentData[fieldName as keyof IMoveReservationParameters] as number) = 0;
                                }
                                setFormData(currentData);
                            }}
                        />
                    </Col>
                </Row></>}
            </div>
            <div
                style={{
                    float: "right",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                }}
            >
                <Button
                    buttonType="button"
                    buttonUIVariant="primary"
                    buttonSize="medium"
                    buttonLabel={t("general.buttons.config", { ns: "app" })}
                    buttonIcon=""
                    isDisabled={appUserRole === AppUserRole.READER || !formData}
                    onClickEvent={(event: Event) => {
                        //console.log(formData)
                        setViewConfirmModal(true)
                    }}
                />
            </div>

            {viewConfirmModal && 
            <>
                <MyBookingModal type={'settingsMoveParameters'} onClose={() => setViewConfirmModal(false)} saveData={postData} />
            </>}
        </>
    );
};
export default MoveReservationParametersView;
